
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export const PluginFeatures = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Plugin Features</CardTitle>
        <CardDescription>
          Our WordPress plugin provides comprehensive backup functionality.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ul className="list-disc pl-5 space-y-2">
          <li>Secure API connection to your backup dashboard</li>
          <li>WordPress user authentication support</li>
          <li>Full website backups (files and database)</li>
          <li>Background processing for large websites</li>
          <li>Incremental backup support to save storage space</li>
          <li>Backup scheduling and automation</li>
          <li>One-click restore functionality</li>
        </ul>
      </CardContent>
    </Card>
  );
};
